// import { ListViewProvider, useListView } from '../core/ListViewProvider'
// import { QueryRequestProvider, useQueryRequest } from '../core/QueryRequestProvider'
// import { QueryResponseProvider } from '../core/QueryResponseProvider'
// import { UsersListHeader } from '../components/header/UsersListHeader'
// import { UsersTable } from '../table/UsersTable'
// import { UserEditModal } from '../form-edit-modal/CoomonEditModal'
// import { KTCard, initialQueryState } from '../../../../../../_metronic/helpers'
// import { Card4 } from '../../../../../../_metronic/partials/content/cards/Card4'
// import { roleColumns } from './_columns'
// import { useEffect, useState } from 'react'
// import { useQuery } from 'react-query'
// import { getUserById } from '../core/_requests'
// import { useAuth } from '../../../../auth'

// const UsersList = () => {
//   const { auth, isSupplyChainManager, currentUser } = useAuth()
//   console.log("curr is", currentUser)
//   const hideDropdown = auth?.data?.userType === 'SMART_CENTRE' || false
//   const { data } = useQuery(
//     `users?page=0&size=10&type=FRANCHISE`,
//     () => getUserById('', 'users?page=0&size=10&type=FRANCHISE'),
//     {
//       enabled: hideDropdown,
//       cacheTime: 0,
//       onError: (err) => {
//         console.warn(err)
//       },
//     }
//   )

//   // const getInitialApi = () => {
//   //   if (auth?.data?.userType === "FRANCHISE_USER" || auth?.data?.userType === "CLIENT") {
//   //     return 'collect/orders?page=0&size=10&wasteSource=C2B'
//   //   }
//   //   return 'collect/orders'
//   // }


//   const getInitialApi = () => {
//     if (auth?.data?.userType === "FRANCHISE_USER" || auth?.data?.userType === "CLIENT") {
//       return 'collect/orders?wasteSource=C2B'  // Keep this as is
//     }
//     return 'collect/orders'
//   }


//   const { updateState } = useQueryRequest()
//   const [categoriesList, setCategoriesList] = useState([{ label: 'Select one', value: '' }])
//   useEffect(() => {
//     if (data && data.length) {
//       let dropdownData: any = [{ label: 'Select one', value: '' }]
//       data.map((eachData) => {
//         return dropdownData.push({ label: eachData?.personalDetails?.name, value: eachData.id })
//       })
//       setCategoriesList(dropdownData)
//       updateState({
//         enabled: true,
//         initialApi: `categories/${dropdownData[0]?.value}/items`,
//         ...initialQueryState,
//       })
//     }
//   }, [data])
//   const searchElements = [
//     {
//       type: 'datePicker',
//       name: 'start_date',
//       label: 'Start date',
//     },
//     {
//       type: 'datePicker',
//       name: 'end_date',
//       label: 'End date',
//     },

//     {
//       ...(hideDropdown && {
//         type: 'select',
//         value: 'select',
//         options: categoriesList,
//         name: 'franchiseeid',
//         label: 'Franchise',
//       }),
//     },
//   ]
//   const { itemIdForUpdate } = useListView()
//   return (
//     <KTCard>
//       {/* <UsersListHeader
//         showDownload
//         showResetButton={true}
//         initialApi='collect/orders'
//         searchElements={searchElements}
//         placeholder='Search Category'
//       />
//       <UsersTable
//         initialApi='collect/orders'
//         showPagination={true}
//         columnProps={roleColumns(isSupplyChainManager)}
//       /> */}
//       <UsersListHeader
//         showDownload
//         showResetButton={true}
//         initialApi={getInitialApi()}  // Use the same function
//         searchElements={searchElements}
//         placeholder='Search Category'
//       />
//       <UsersTable
//         initialApi={getInitialApi()}  // Use the same function
//         showPagination={true}
//         columnProps={roleColumns(isSupplyChainManager)}
//       />
//       <UserEditModal
//         // getByIdApi='collect/orders/'
//         showViewPage={itemIdForUpdate?.showCertificate ? true : false}
//         formName='MaterialInwardModalForm'
//       />
//     </KTCard>
//   )
// }

// // const CollectOrdersWrapper = () => (
// //   <QueryRequestProvider initialValue={{ initialApi: 'collect/orders' }}>
// //     <QueryResponseProvider>
// //       <ListViewProvider>
// //         <UsersList />
// //       </ListViewProvider>
// //     </QueryResponseProvider>
// //   </QueryRequestProvider>
// // )


// const CollectOrdersWrapper = () => {
//   const { auth } = useAuth()

//   const getInitialApi = () => {
//     if (auth?.data?.userType === "FRANCHISE_USER" || auth?.data?.userType === "CLIENT") {
//       return 'collect/orders?wasteSource=C2B'
//     }
//     return 'collect/orders'
//   }

//   return (
//     <QueryRequestProvider initialValue={{ initialApi: getInitialApi(), size: 50 }}>
//       <QueryResponseProvider>
//         <ListViewProvider>
//           <UsersList />
//         </ListViewProvider>
//       </QueryResponseProvider>
//     </QueryRequestProvider>
//   )
// }

// export { CollectOrdersWrapper }






























import { ListViewProvider, useListView } from '../core/ListViewProvider'
import { QueryRequestProvider, useQueryRequest } from '../core/QueryRequestProvider'
import { QueryResponseProvider } from '../core/QueryResponseProvider'
import { UsersListHeader } from '../components/header/UsersListHeader'
import { UsersTable } from '../table/UsersTable'
import { UserEditModal } from '../form-edit-modal/CoomonEditModal'
import { KTCard, initialQueryState } from '../../../../../../_metronic/helpers'
import { Card4 } from '../../../../../../_metronic/partials/content/cards/Card4'
import { roleColumns } from './_columns'
import { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { getUserById } from '../core/_requests'
import { useAuth } from '../../../../auth'
import TryModal from './TryModal'

const UsersList = () => {
  const { auth, isSupplyChainManager, currentUser } = useAuth()
  const [showAddModal, setShowAddModal] = useState(false)

  console.log("curr is", currentUser)
  const hideDropdown = auth?.data?.userType === 'SMART_CENTRE' || false
  const { data } = useQuery(
    `users?page=0&size=10&type=FRANCHISE`,
    () => getUserById('', 'users?page=0&size=10&type=FRANCHISE'),
    {
      enabled: hideDropdown,
      cacheTime: 0,
      onError: (err) => {
        console.warn(err)
      },
    }
  )

  // const getInitialApi = () => {
  //   if (auth?.data?.userType === "FRANCHISE_USER" || auth?.data?.userType === "CLIENT") {
  //     return 'collect/orders?page=0&size=10&wasteSource=C2B'
  //   }
  //   return 'collect/orders'
  // }


  const getInitialApi = () => {
    if (auth?.data?.userType === "FRANCHISE_USER" || auth?.data?.userType === "CLIENT") {
      return 'collect/orders?wasteSource=C2B'  // Keep this as is
    }
    return 'collect/orders'
  }


  // const { updateState } = useQueryRequest()
  const { updateState, state } = useQueryRequest()
  const handleDownload = async () => {
    try {
      const authData = localStorage.getItem('kt-auth-react-v');
      const authToken = authData ? JSON.parse(authData).data?.token : null;
      if (!authToken) return;
      const params = new URLSearchParams();
      if (auth?.data?.userType === "FRANCHISE_USER" || auth?.data?.userType === "CLIENT") {
        params.append('wasteSource', 'C2B');
      }
      if (state?.status) params.append('status', state.status);
      if (state?.start_date) params.append('start_date', state.start_date);
      if (state?.end_date) params.append('end_date', state.end_date);
      if (state?.franchiseeid) params.append('franchiseeid', state.franchiseeid);

      const response = await fetch(
        `${process.env.REACT_APP_BASE_API_URL}collect/orders/download/csv?${params.toString()}`,
        {
          headers: {
            'Authorization': authToken,
            'Accept-Language': 'en-US,en;q=0.9',
          }
        }
      );

      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `collect-orders-${new Date().toISOString().split('T')[0]}.csv`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      }
    } catch (error) {
      console.error('Download failed:', error);
    }
  };
  const [categoriesList, setCategoriesList] = useState([{ label: 'Select one', value: '' }])
  useEffect(() => {
    if (data && data.length) {
      let dropdownData: any = [{ label: 'Select one', value: '' }]
      data.map((eachData) => {
        return dropdownData.push({ label: eachData?.personalDetails?.name, value: eachData.id })
      })
      setCategoriesList(dropdownData)
      updateState({
        enabled: true,
        initialApi: `categories/${dropdownData[0]?.value}/items`,
        ...initialQueryState,
      })
    }
  }, [data])


  const statusLis = [
    { label: 'Select one', value: '' },
    // { label: 'Pending', value: 'CREATED' },
    { label: 'Pending', value: 'APPROVAL_PENDING' },
    { label: 'Completed', value: 'COMPLETED' },
  ]

  const searchElements = [
    {
      type: 'select',
      value: 'select',
      options: statusLis,
      name: 'status',
      label: 'Status',
    },
    {
      type: 'datePicker',
      name: 'start_date',
      label: 'Start date',
    },
    {
      type: 'datePicker',
      name: 'end_date',
      label: 'End date',
    },
    {
      ...(hideDropdown && {
        type: 'select',
        value: 'select',
        options: categoriesList,
        name: 'franchiseeid',
        label: 'Franchise',
      }),
    },
  ]
  const { itemIdForUpdate } = useListView()
  return (
    <KTCard>
      {/* <UsersListHeader
        showDownload
        showResetButton={true}
        initialApi='collect/orders'
        searchElements={searchElements}
        placeholder='Search Category'
      />
      <UsersTable
        initialApi='collect/orders'
        showPagination={true}
        columnProps={roleColumns(isSupplyChainManager)}
      /> */}


      {/* <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px' }}>
      <UsersListHeader
        // showDownload
        showResetButton={true}
        initialApi={getInitialApi()}  
        searchElements={searchElements}
        placeholder='Search Category'
        csvDownload={true}
        onCsvDownload={handleDownload} 
      />
      {(currentUser as any).userType === 'PICKUP_POINT_STAFF' && (
        <div className='d-flex justify-content-end mb-4' style={{ marginRight: '30px' }}>
          <button
            className='btn btn-primary'
            onClick={() => setShowAddModal(true)}
            style={{ backgroundColor: '#333333', borderColor: '#333333' }}
          >
            Add New
          </button>
        </div>
      )}
      </div> */}


      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px' }}>
        <UsersListHeader
          showResetButton={true}
          initialApi={getInitialApi()}
          searchElements={searchElements}
          placeholder='Search Category'
          csvDownload={true}
          onCsvDownload={handleDownload}
        />
        {(currentUser as any).userType === 'PICKUP_POINT_STAFF' && (
          <button
            className='btn btn-primary'
            onClick={() => setShowAddModal(true)}
            style={{
              marginTop: "10px",
              marginRight: "10px",
              backgroundColor: '#333333',
              borderColor: '#333333',
              height: '44px',
              whiteSpace: 'nowrap'
            }}
          >
            Add new
          </button>
        )}
      </div>

      <UsersTable
        initialApi={getInitialApi()}  // Use the same function
        showPagination={true}
        columnProps={roleColumns(isSupplyChainManager)}
      />
      <UserEditModal
        // getByIdApi='collect/orders/'
        showViewPage={itemIdForUpdate?.showCertificate ? true : false}
        formName='MaterialInwardModalForm'
      />

      {showAddModal && (
        <>
          {/* Overlay */}
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(26, 26, 26, 0.7)', // #999999 with 50% opacity
              zIndex: 1040,
            }}
            onClick={() => setShowAddModal(false)}
          />

          {/* Modal */}
          <div
            className='modal d-block'
            tabIndex={-1}
            role='dialog'
            style={{ zIndex: 1050 }}
          >
            <div className='modal-dialog modal-lg' role='document'>
              <div className='modal-content'>
                <div className='modal-header'>
                  <p className='modal-title mb-0' style={{ fontSize: '15px', fontWeight: 'bold' }}>Add</p>
                  <button
                    type='button'
                    className='close'
                    onClick={() => setShowAddModal(false)}
                    style={{
                      background: 'none',
                      border: 'none',
                      fontSize: '1.5rem',
                      cursor: 'pointer'
                    }}
                  >
                    <span>&times;</span>
                  </button>
                </div>
                <div className='modal-body'>
                  <TryModal onClose={() => setShowAddModal(false)} />
                </div>
              </div>
            </div>
          </div>
        </>
      )}

    </KTCard>
  )
}

// const CollectOrdersWrapper = () => (
//   <QueryRequestProvider initialValue={{ initialApi: 'collect/orders' }}>
//     <QueryResponseProvider>
//       <ListViewProvider>
//         <UsersList />
//       </ListViewProvider>
//     </QueryResponseProvider>
//   </QueryRequestProvider>
// )


const CollectOrdersWrapper = () => {
  const { auth } = useAuth()

  const getInitialApi = () => {
    if (auth?.data?.userType === "FRANCHISE_USER" || auth?.data?.userType === "CLIENT") {
      return 'collect/orders?wasteSource=C2B'
    }
    return 'collect/orders'
  }

  return (
    <QueryRequestProvider initialValue={{ initialApi: getInitialApi(), size: 50 }}>
      <QueryResponseProvider>
        <ListViewProvider>
          <UsersList />
        </ListViewProvider>
      </QueryResponseProvider>
    </QueryRequestProvider>
  )
}

export { CollectOrdersWrapper }
